<template>
  <div
    class="m-dropdown-content m-dropdown-content-left"
    id="MoleculeEditionBillingMySalesInvoicesHistoryDropDownFilters"
  >
    <section
      v-if="showLoadingState < 2"
      key="loadingState"
      class="m-dropdown-section"
    >
      <ul class="m-dropdown-list">
        <li>
          <a
            href="#"
            @click.prevent=""
          >
            <AtomLoadingSecondary/>
          </a>
        </li>
      </ul>
    </section>
    <form
      v-else
      key="billingMySalesDropDownFilters"
      autocomplete="off"
      name="MySalesDropDownFilters"
      spellcheck="false"
      @submit.prevent="searchAdvancedFilter"
    >
      <section class="m-dropdown-section">
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.input.estado.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <ul>
                <li
                  v-for="(estado, index) in estadosInvoice"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.estado"
                    inputStyle="billing"
                    name="estado"
                    :text="estado.name"
                    :value="estado.id"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.input.pais.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomSelectPrimary
                v-model="filter.pais"
                :elements="paisesSelect"
                key-field="id_pais"
                name="pais"
                reference="pais"
                text-field="nombre"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.input.divisa.label') }}
            </a>
            <div class="m-dropdown-sublist m-dropdown-sublist-scrollable">
              <ul>
                <li
                  v-for="(divisa, index) in divisas"
                  :key="index"
                >
                  <AtomCheckboxPrimary
                    v-model="filter.divisa"
                    inputStyle="billing"
                    name="moneda"
                    :text="divisa.nombre"
                    :value="divisa.iso_code"
                    wrapper-class="margin-zero"
                  />
                </li>
              </ul>
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.input.fechaDesde.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_desde"
                label=""
                name="fecha_desde"
                :placeholder="$t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.input.fechaDesde.placeholder')"
              />
            </div>
          </li>
        </ul>
        <ul class="m-dropdown-list">
          <li>
            <a
              href="#"
              @click.prevent=""
            >
              {{ $t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.input.fechaHasta.label') }}
            </a>
            <div class="m-dropdown-sublist">
              <AtomDatePicker
                v-model="filter.fecha_hasta"
                :disabled-dates="disabledDates"
                name="fecha_hasta"
                :placeholder="$t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.input.fechaHasta.placeholder')"
              />
            </div>
          </li>
        </ul>
      </section>
      <footer class="m-dropdown-footer">
        <button
          class="a-button-dropdown-secondary"
          @click="reloadListing"
        >
          {{ $t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.buttonSecondary.restartText') }}
        </button>
        <button
          class="a-button-primary a-button-billing-primary a-button-dropdown-primary"
          type="submit"
        >
          {{ $t('mEditionBillingMySalesInvoicesHistoryDropDownFilters.buttonPrimary') }}
        </button>
      </footer>
    </form>
  </div>
</template>

<script>
export default {
  name: 'MoleculeEditionBillingMySalesInvoicesHistoryDropDownFilters',

  props: {
    filterSeted: Object
  },

  data () {
    return {
      disabledDates: {
        to: ''
      },

      divisas: [],
      estadosInvoice: [],

      filter: {
        buscar: '',
        divisa: [],
        estado: [],
        fecha_desde: '',
        fecha_hasta: '',
        limite: 10,
        pagina: 1,
        pais: '',
        punto_venta: []
      },

      pasarelasPago: [],
      paises: [],
      productos: [],
      showLoadingState: 0
    }
  },

  computed: {
    paisesSelect () {
      let paises = [...this.paises]
      paises.unshift({
        id_pais: '',
        nombre: this.$t('mEditionBillingMySalesDropDownFilters.input.pais.firstOption')
      })
      return paises
    }
  },

  watch: {
    'filter.fecha_desde' () {
      if (this.$moment(this.filter.fecha_desde).isAfter(this.filter.fecha_hasta)) {
        this.filter.fecha_hasta = null
      }

      this.disabledDates = {
        to: this.filter.fecha_desde
      }
    },

    filterSeted: {
      deep: true,

      handler () {
        this.filter.buscar = this.filterSeted.buscar
        this.filter.divisa = [...this.filterSeted.divisa]
        this.filter.punto_venta = []
        this.filter.estado = [...this.filterSeted.estado]
        this.filter.fecha_desde = this.filterSeted.fecha_desde
        this.filter.fecha_hasta = this.filterSeted.fecha_hasta
        this.filter.pais = this.filterSeted.pais

        this.disabledDates = {
          to: this.filter.fecha_desde
        }
      },

      immediate: true
    }
  },

  created () {
    this.estadosInvoice = [...this.$filters.parameters.invoiceStates]
    this.estadosInvoice.shift()
    this.readDivisas()
    this.readParametroPaises()
  },

  methods: {
    readDivisas () {
      this.$services.read('divisa', 'readDivisas')
        .then(response => {
          this.divisas = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    readParametroPaises () {
      this.$services.read('parametro', 'readParametroPaises')
        .then(response => {
          this.paises = response.data
          this.showLoadingState++
        })
        .catch(error => {
          console.log(error)
          this.showLoadingState++
        })
    },

    reloadListing () {
      this.$emit('reloadListing')
    },

    searchAdvancedFilter () {
      this.$dropDown.switchDropDown('MoleculeEditionBillingMySalesInvoicesHistoryDropDownFilters')
      this.$emit('searchAdvancedFilter', this.filter)
    }
  }
}
</script>
